import { ref, type Ref } from "vue";

import type { MapFilter } from "@/services/mapService";

type MapView = "map" | "map-parking" | "map-toll";

interface MapViewState {
  mapView: Ref<MapView>;
}

const createMapViewState = (): MapViewState => ({
  mapView: ref<MapView>("map-parking")
});

let sharedMapViewState: MapViewState | null = null;

const getMapViewState = () => {
  sharedMapViewState ??= createMapViewState();
  return sharedMapViewState;
};

const setMapViewFromFilter = (filter: MapFilter | null) => {
  const mapView = getMapViewState().mapView;
  if (filter === "toll") {
    mapView.value = "map-toll";
    return;
  }
  if (filter === "parking") {
    mapView.value = "map-parking";
    return;
  }
  mapView.value = "map";
};

const setMapViewExplicit = (view: MapView) => {
  getMapViewState().mapView.value = view;
};

const useMapViewState = () => getMapViewState().mapView;

export { setMapViewExplicit, setMapViewFromFilter, useMapViewState };
